import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusBadge, inr, fmtDate } from "@/components/common";
import DataTable from "@/components/DataTable";

export default function Payments() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/payments").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  const columns = [
    { key: "total_fee", label: "Total Fee", render: (r) => inr(r.total_fee) },
    { key: "agreed_fee", label: "Agreed", render: (r) => inr(r.agreed_fee) },
    { key: "scholarship", label: "Scholarship", render: (r) => inr(r.scholarship) },
    { key: "paid", label: "Paid", render: (r) => <span className="font-semibold text-emerald-600">{inr(r.paid)}</span> },
    { key: "balance", label: "Balance", render: (r) => <span className="font-semibold text-rose-600">{inr(r.balance)}</span> },
    { key: "mode", label: "Mode" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "created_at", label: "Date", render: (r) => <span className="text-xs">{fmtDate(r.created_at)}</span> },
  ];
  const totalPaid = (rows || []).reduce((s, r) => s + (r.paid || 0), 0);
  const totalBal = (rows || []).reduce((s, r) => s + (r.balance || 0), 0);
  return (
    <div>
      <PageHeader title="Student Payments" subtitle="Fee collection & outstanding balances" testid="payments-header" />
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
        <Stat label="Collected" value={inr(totalPaid)} tone="text-emerald-600" />
        <Stat label="Outstanding" value={inr(totalBal)} tone="text-rose-600" />
        <Stat label="Records" value={(rows || []).length} tone="text-[#312E81]" />
      </div>
      <DataTable columns={columns} rows={rows} loading={rows === null} testid="payments-table" />
    </div>
  );
}
function Stat({ label, value, tone }) {
  return <div className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm"><div className={`font-heading text-xl font-extrabold ${tone}`}>{value}</div><div className="text-xs text-slate-500">{label}</div></div>;
}
